module.exports = __webpack_public_path__ + "media/src/images/icon__magazinHappy2--dark-5132a2889ea53d83d9c198cbeae5cb32.svg";